<template>
  <div class="homework_detail">
    <div
      class="flex Flexalign cursor_pointer back_box FlexEnd FlexjustifyEnd"
      @click="goBack"
      v-if="showBack"
    >
      <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
      <div class="mar_left_10">返回</div>
    </div>
    <div class="homework_name">{{ paperInfo.paperName }}</div>
    <div class="homework_info flex Flexalign Flexjustify mt-15">
      <div class="flex Flexalign mr-24">
        <el-image
          class="test_question_num"
          :src="iconPath('test_question_num.png')"
        ></el-image>
        <div class="ml-5">试题数：{{ paperInfo.questionCount }}题</div>
      </div>
      <div class="flex Flexalign mr-24">
        <el-image
          class="test_question_num"
          :src="iconPath('test_total_score.png')"
        ></el-image>
        <div class="ml-5">试卷总分：{{ paperInfo.fullScore }}分</div>
      </div>
      <div class="flex Flexalign">
        <el-image
          class="test_question_num"
          :src="iconPath('test_time_icon.png')"
        ></el-image>
        <div class="ml-5">作答时间：{{ paperInfo.answerTime }}分钟</div>
      </div>
    </div>
    <!-- 暂无难度以及知识点概况，先行隐藏 -->
    <!-- <div class="homework_difficult flex Flexalign mt-30">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">整体难度</div>
      <div
        class="difficult_one ml-15"
        v-for="(item, index) in difficultList"
        :key="index"
        :class="[item.value == homeworkInfo.difficult ? 'difficult_one_actove' : '']"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="question_range mt-15">考试范围{{ homeworkInfo.questionRange }}</div> -->
    <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">试卷类型</div>
    </div>
    <div class="question_proportion mt-10">
      <div class="proportion_one proportion_one_top flex">
        <div class="question_type">题型</div>
        <div class="question_num">数量</div>
        <div class="question_num">占比</div>
      </div>
      <div
        class="proportion_one flex"
        v-for="(item, index) in homeworkInfo.questionProportion"
        :key="index"
      >
        <div class="question_type">{{ item.questionTypeName }}</div>
        <div class="question_num">{{ item.questionTypeCount }}</div>
        <div class="question_num">{{ item.ratio }}%</div>
      </div>
    </div>
    <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">难度占比</div>
    </div>
    <div class="flex Flexalign mt-10 charts_box Flexjustify">
      <difficultProportionPie
        :height="300"
        :width="700"
        ref="difficultProportionPie"
      ></difficultProportionPie>
    </div>
    <div class="btn_answer mt-15 cursor_pointer" @click="startAnswer">开始作答</div>
    <!-- <div class="answer_record mt-15 cursor_pointer" @click="openRecord">作答记录（6）</div> -->
    <answerRecord ref="answerRecord"></answerRecord>
  </div>
</template>

<script>
import difficultProportionPie from "@/components/echarts/difficultProportionPie.vue";
import answerRecord from "@/components/popup/answerRecord.vue";
import { debounce } from "@/assets/utils/dbucTrtl";
export default {
  name: "GjkcH5HomeworkDetail",

  components: { difficultProportionPie, answerRecord },
  props: {
    paperInfo: {},
    showBack: {
      default: false,
    },
    homeworkType: {},
  },
  inject: ["practiceBack", "updateShowPractice"],

  data() {
    return {
      difficultList: [
        { label: "容易", value: 1 },
        { label: "较易", value: 2 },
        { label: "适中", value: 3 },
        { label: "困难", value: 4 },
      ],
      homeworkInfo: {
        name: "2025-5月30号课后作业",
        questionNum: 20,
        fullScore: 100,
        effectiveTime: 60,
        difficult: 3,
        questionRange:
          "考察范围：集合与常用逻辑，函数与导数，计考察范围：集合与常用逻辑，函数与导数，计",
        questionProportion: [],
        difficultProportion: [],
      },
    };
  },

  mounted() {
    if (this.paperInfo?.paperId) {
      this.goFinishHomework();
    } else {
      this.$Dialog.toast("当前试卷暂未配置相关试题", { type: "warning" });
      this.$emit("goBack");
    }
  },

  methods: {
    goBack() {
      this.$emit("changeStep", 1);
    },
    openRecord() {
      this.$refs.answerRecord.answerRecordShow = true;
    },
    // startAnswer(){
    //     this.updateShowPractice(true,this.paperInfo.paperId);
    // },
    startAnswer() {
      this.startTest();
    },
    startTest: debounce(
      function () {
        this.updateShowPractice(true, this.paperInfo.paperId,undefined,this.homeworkType);
      },
      1000,
      false
    ),
    goFinishHomework() {
      if (this.homeworkType == "homework") {
        this.$Api.course
          .goFinishHomework(this.paperInfo.paperId)
          .then((res) => {
            this.homeworkInfo.questionProportion = res.data.data?.questionTypeCount;
            let chartsData = [];
            res.data.data?.difficultyRatio.indicator.forEach((item, index) => {
              chartsData.push({
                value: res.data.data?.difficultyRatio.value[index],
                name: item,
              });
            });
            this.$refs.difficultProportionPie.initCharts(chartsData);
          })
          .catch(() => {});
      } else {
        this.$Api.exam
          .getAfterHomeworkPaperCount(this.paperInfo.paperId)
          .then((res) => {
            this.homeworkInfo.questionProportion = res.data.data?.questionTypeCount;
            let chartsData = [];
            res.data.data?.difficultyRatio.indicator.forEach((item, index) => {
              chartsData.push({
                value: res.data.data?.difficultyRatio.value[index],
                name: item,
              });
            });
            this.$refs.difficultProportionPie.initCharts(chartsData);
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.homework_detail {
  .back_box {
    width: 100%;
    font-size: 18px;
    color: #13d6aa;

    .back_icon {
      width: 24px;
      height: 24px;
    }
  }
  .homework_name {
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #111111;
  }

  .homework_info {
    .test_question_num {
      width: 22px;
      height: 22px;
    }
  }

  .homework_difficult {
    font-size: 12px;
    color: #999999;

    .line_green {
      width: 3px;
      height: 16px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 4px;
    }

    .difficult_text {
      font-size: 14px;
      color: #111111;
    }

    .difficult_one {
      width: 60px;
      height: 25px;
      background: #f5f5f5;
      border-radius: 15px;
      line-height: 25px;
      text-align: center;
    }

    .difficult_one_actove {
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      color: #fff;
    }
  }

  .question_range {
    font-size: 14px;
    color: #666666;
  }

  .question_proportion {
    .proportion_one {
      width: 344px;
      height: 45px;
      font-size: 14px;
      color: #666666;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04);
      text-align: center;
      line-height: 45px;

      .question_type {
        width: 40%;
      }

      .question_num {
        width: 30%;
      }
    }

    .proportion_one_top {
      background: #f7f7fa;
      font-size: 14px;
      color: #111111;
    }
  }

  .charts_box {
    width: 100%;
  }

  .btn_answer {
    width: 160px;
    height: 48px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 30px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    margin: 0 auto;
  }

  .answer_record {
    font-size: 14px;
    color: #13d6aa;
    margin: 10px auto;
    text-align: center;
  }
}
</style>
